// @flow
import React, { Component, type Node } from 'react';
import styled from 'styled-components';

import { mergeClassNames } from 'utils/functions';

const StyledLoadingTable = styled.table`
    td {
        border-top: 1px solid #eee;
        padding: 0;
    }
`;

type Props = {
    headers: Array<Node>,
    rowsToDisplay: number,
    className: string,
};

export class LoadingTable extends Component<Props> {
    static defaultProps = {
        className: '',
        headers: ['Loading...'],
        rowsToDisplay: 30,
    };

    render() {
        const { className, headers, rowsToDisplay } = this.props;
        let mergedClasses = mergeClassNames(
            `table ${className} table-striped table-sm list-items-table loading`
        );
        let rows = [];
        const columns = headers.length;

        for (let i = 0; i < rowsToDisplay; i++) {
            rows.push(
                <tr key={i}>
                    <td colSpan={columns}> &nbsp; </td>
                </tr>
            );
        }

        return (
            <StyledLoadingTable className={mergedClasses}>
                <React.Fragment>
                    <tbody>{rows}</tbody>
                </React.Fragment>
            </StyledLoadingTable>
        );
    }
}

export default LoadingTable;
